module.exports = __webpack_public_path__ + "img/program-watchparty.ccb56787.jpg";